import * as consumptionMap from './consumptionMap'
import * as controlledProducts from './controlledProducts'
import * as controlledProductReport from './controlledProductReport'
import * as license from './license'
import * as menu from './menu'
import * as productMap from './productMap'
import * as login from './login'
import * as auth from './auth'
import * as area from './area'
import * as incompatibilityAnalysis from './incompatibilityAnalysis'
import * as overview from './overview'
import * as inventory from './inventory'
import * as report from './report'
import * as cabinetProducts from './cabinetProducts'
import * as areaFds from './areaFds'
import * as productFds from './productFds'
import * as fispq from './fispq'
import * as news from './news'
import * as certificateControls from './certificateControls'
import * as measures from './measures'

export {
  consumptionMap,
  controlledProducts,
  controlledProductReport,
  license,
  menu,
  productMap,
  login,
  auth,
  incompatibilityAnalysis,
  area,
  overview,
  inventory,
  report,
  cabinetProducts,
  areaFds,
  productFds,
  fispq,
  news,
  certificateControls,
  measures
}



// WEBPACK FOOTER //
// ./src/api/index.js